export default __webpack_public_path__ + "static/media/1805.b0df3965.png";